import { useMutation } from '@tanstack/react-query'
import { MainApi } from 'api/MainApi'
import { ICleaningZone, ICleaningZonePoint, ZoneCreateData } from 'utils/interfaces'

interface ReceiveData {
  zone: ICleaningZone
  startingPoint: ICleaningZonePoint | undefined
  endingPoint: ICleaningZonePoint | undefined
}

const useCreateCleaningZone = () =>
  useMutation<ReceiveData, Error, ZoneCreateData>({
    mutationFn: MainApi.createCleaningZone,
  })

export default useCreateCleaningZone
